import { useRef, useState, useLayoutEffect } from 'react';
import './VR.css';
import './stereo-img';
import 'exifr';
import 'three';

const VR = ({ reel }) => {
    const [index, setIndex] = useState(1);
    const imgElement = useRef(null);

    useLayoutEffect(() => {
        if (!imgElement.current) {
          return;
        }
        imgElement.current.next = () => {
            if (index < 7) setIndex(index + 1);
            else setIndex(1);
        };
        imgElement.current.prev = () => {
            if (index > 1) setIndex(index - 1);
            else setIndex(7);
        };
      }, [index]);

    return (
        <div className="VR" onClick={() => {
            if (index < 7) setIndex(index + 1);
            else setIndex(1);
        }}>
            <stereo-img class="stereo-img" src={`${process.env.PUBLIC_URL }/images/${reel}/${index}.png`} ref={imgElement}></stereo-img>
        </div>
    );
}

export default VR;